<template>
  <div>
    <PageHeader title="Contact" />

    <ContactForm/>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Contact.vue',
  components: { PageHeader, ContactForm },
};
</script>
